import { ConditionalContextProvider } from '@snowplow/browser-tracker'
import { FunnelContextDataProvider } from 'Snowplow'
import { funnelContextFilter, funnelContextGenerator } from './funnelContextProvider'

function funnelContextProvider(
  dataProvider: FunnelContextDataProvider
): ConditionalContextProvider {
  return [funnelContextFilter(), funnelContextGenerator(dataProvider)]
}

export { funnelContextProvider }
